import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import { useDispatch, useSelector } from "react-redux";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { useParams } from "react-router-dom";
import Toast from "../../../Component/DigitalMarketing/Toast";
import PatientDetails from "./PatientDetails";
import CustomerBloodAppointment from "./CustomerBloodAppointment";
import { useGetBloodAppoinmentbyIdQuery, useGetBloodPatientDetailsbyIdQuery, useGetPatientDetailsbyIdQuery } from "../../../Service/appoinment";

function UpdateBloodAppointment() {
  const { id } = useParams();
  const response: any = useGetBloodPatientDetailsbyIdQuery(id);
  const response1: any = useGetBloodAppoinmentbyIdQuery(id);

console.log(response);
console.log(response1);

 
  const { open, message, openSnackBar, type } = useSnackbar();
  const dispatch = useDispatch();
  const callBackforErrorMessage = (value = true) => {
   
  };



  useEffect(() => {
    const data: any = {
      first: "Blood-Appointments",
      second:
        window.location.pathname.split("/")[2] === "add"
          ? "New Blood Appointment"
          : response?.data?.[0]?.customerName,
    };
    dispatch(Change(data));
  }, [response?.data?.[0]?.customerName]);
  return (
    <Row>
      <Toast open={open} type={type} message={message} />
      {window.location.pathname.split("/")[2] === "add" ? (
        ""
      ) : (
        <Col md={6}>
          <div className="cards-box">
            <PatientDetails patientdata={response?.data?.[0]} />
          </div>
        </Col>
      )}
      <Col md={6}>
        <div className="Appointment">
          <ul className="Appointment-ul md-bord">
            <CustomerBloodAppointment
              openSnackBar={openSnackBar}
              details={response1.data?.[0]}
              id={id}
              callBackforErrorMessage={callBackforErrorMessage}
            />
          </ul>
        </div>
      </Col>
    </Row>
  );
}

export default UpdateBloodAppointment;
